<template>
  <div class="max-h-[calc(70vh-120px)]">
    <AlertLayout
      title="Why Set Up your Inventory stock?"
      message="Setting up your services makes it easy to manage what your facility offers and ensures everything runs smoothly for you and your clients."
      type="warning"
    />
    <div
      v-for="(stock_item, index) in stock_items"
      :key="index"
      class="grid grid-cols-6 gap-x-6 gap-y-6 flex px-10 mt-5"
    >
      <div>
        <label for="department" class="block text-sm font-medium text-gray-700"
          >Batch No<span class="text-red-500">*</span></label
        >
        <input
          type="text"
          id="genericName"
          v-model="stock_item.batch_no"
          placeholder="Enter Batch No"
          class="mt-1 block w-full rounded-sm border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50"
        />
        <span class="text-xs text-red-500" v-if="stock_item.errors.batch_no">{{
          stock_item.errors.batch_no
        }}</span>
      </div>

      <div>
        <label for="serviceType" class="block text-sm font-medium text-gray-700"
          >Expiry Date<span class="text-red-500">*</span></label
        >
        <input
          type="date"
          id="genericName"
          v-model="stock_item.expiry_date"
          :min="minDate"
          placeholder="Enter batch expiry date"
          class="mt-1 block w-full rounded-sm border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50"
        />
        <span
          class="text-xs text-red-500"
          v-if="stock_item.errors.expiry_date"
          >{{ stock_item.errors.expiry_date }}</span
        >
      </div>

      <div>
        <label for="serviceType" class="block text-sm font-medium text-gray-700"
          >Quantity<span class="text-red-500">*</span></label
        >
        <input
          type="number"
          id="quantity"
          v-model="stock_item.quantity"
          placeholder="Enter quantity"
          class="mt-1 block w-full rounded-sm border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50"
        />
        <span class="text-xs text-red-500" v-if="stock_item.errors.quantity">{{
          stock_item.errors.quantity
        }}</span>
      </div>
      <div>
        <label for="cost" class="block text-sm font-medium text-gray-700"
          >Unit Cost Price<span class="text-red-500">*</span></label
        >
        <input
          type="number"
          id="cost"
          v-model="stock_item.cost_price"
          min="0.00"
          class="mt-1 block w-full rounded-sm border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50"
        />
        <span
          class="text-xs text-red-500"
          v-if="stock_item.errors.cost_price"
          >{{ stock_item.errors.cost_price }}</span
        >
      </div>

      <div>
        <label for="cost" class="block text-sm font-medium text-gray-700"
          >Unit Selling Price<span class="text-red-500">*</span></label
        >
        <input
          type="number"
          id="cost"
          v-model="stock_item.selling_price"
          min="0.00"
          class="mt-1 block w-full rounded-sm border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
        />
        <span
          class="text-xs text-red-500"
          v-if="stock_item.errors.selling_price"
          >{{ stock_item.errors.selling_price }}</span
        >
      </div>
      <div>
        <div
          class="flex mt-6 space-x-4"
          v-if="index === stock_items.length - 1"
        >
          <svg
            @click="addServiceRow"
            class="text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="yellow"
            viewBox="0 0 18 18"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 12h14m-7 7V5"
            />
          </svg>
          <DeleteIcon
            v-if="stock_items.length > 1"
            @click="deleteItem(index)"
          />
        </div>
      </div>
    </div>
    <div class="flex mt-4 space-x-4 px-10">
      <button
        type="button"
        data-modal-hide="modal"
        class="px-6 mb-4 py-2 bg-gray-200 text-gray-800 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
      >
        Cancel
      </button>
      <button
        type="button"
        @click="handleSubmit"
        class="px-6 mb-4 r-4 py-2 bg-custom-yellow text-white hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50"
      >
        <span v-if="!showLoader">Submit</span>
        <span v-else class="absolute inset-0 flex justify-center items-center">
          <svg
            class="animate-spin h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
              fill="none"
            />
          </svg>
        </span>
      </button>
    </div>
  </div>
</template>
<script>
import apiClient from "@/services/api";
import AlertLayout from "@/components/AlertLayout.vue";
import DeleteIcon from "@/components/buttons/DeleteIcon.vue";

export default {
  name: "AddInventoryItemStock",
  components: {
    AlertLayout,
    DeleteIcon,
  },
  data() {
    return {
      loading: true,
      error: null,
      stock_items: [
        {
          batch_no: "",
          expiry_date: "",
          cost_price: 0,
          selling_price: 0,
          quantity: 0,
          errors: {},
        },
      ],
      serviceTypes: [],
      inventoryItemId: "",
      showLoader: false,
    };
  },
  mounted() {
    this.inventoryItemId = this.$route.params.id;
  },
  computed: {
    minDate() {
      return new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
    },
  },
  methods: {
    addServiceRow() {
      if (!this.validateForm()) {
        return;
      }
      this.stock_items.push({
        batch_no: "",
        expiry_date: "",
        cost_price: 0,
        selling_price: 0,
        quantity: 0,
        errors: {
          batch_no: "",
          expiry_date: "",
          cost_price: "",
          selling_price: "",
          quantity: "",
        },
      });
    },
    validateForm() {
      let isValid = true;

      this.stock_items.forEach((stock_item) => {
        stock_item.errors = {}; // Reset errors

        if (!stock_item.batch_no) {
          stock_item.errors.batch_no = "Batch number is required.";
          isValid = false;
        }
        if (!stock_item.expiry_date) {
          stock_item.errors.expiry_date = "Expiry date is required.";
          isValid = false;
        }
        if (stock_item.cost_price <= 0) {
          stock_item.errors.cost_price = "Cost Price must be greater than 0.";
          isValid = false;
        }

        if (stock_item.quantity <= 0) {
          stock_item.errors.quantity = "Quantity must be greater than 0.";
          isValid = false;
        }

        if (stock_item.selling_price <= 0) {
          stock_item.errors.selling_price =
            "Selling Price must be greater than 0.";
          isValid = false;
        }

        if (stock_item.cost_price > stock_item.selling_price) {
          stock_item.errors.selling_price =
            "Cost price cannot be greater than selling price.";
          isValid = false;
        }
      });
      return isValid;
    },
    deleteItem(index) {
      this.stock_items.splice(index, 1);
    },
    async handleSubmit() {
      try {
        if (!this.validateForm()) {
          return;
        }

        this.showLoader = true;

        const payload = {
          stock_items: this.stock_items,
          inventory_item_id: this.inventoryItemId,
        };
        const response = await apiClient.createInventoryStockItem(payload);
        if (response.success) {
          this.showLoader = false;
          this.$toast.success("Inventory item stock added successfully");
          this.$router.push("/view-inventory-items/" + this.inventoryItemId);
        } else {
          this.$toast.error("Failed to create inventory stock items");
        }
      } catch (error) {
        this.showLoader = false;
        this.$toast.error("Failed to create inventory stock items");
        console.log(error);
      }
    },
  },
};
</script>
